import { IApplicationState } from '../../types/redux';

export function getNewbuildingName(state: IApplicationState) {
  const {
    newbuilding: { name },
  } = state;

  return name;
}
